import { render, staticRenderFns } from "./OhYesAi.vue?vue&type=template&id=451cfc6e&scoped=true"
import script from "./OhYesAi.vue?vue&type=script&lang=js"
export * from "./OhYesAi.vue?vue&type=script&lang=js"
import style0 from "./OhYesAi.vue?vue&type=style&index=0&id=451cfc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451cfc6e",
  null
  
)

export default component.exports